import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent, DialogConfig } from '@vsolv/vectors-ui/dialog';
import {
  EMAIL_TEMPLATE_EVENT_TYPES,
  EmailTemplateEventType,
  EmailTemplatesService,
} from '../../pages/email-templates/email-templates.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-settings-create-email-template-dialog',
  templateUrl: './create-email-template.dialog.html',
  standalone: false,
})
export class CreateEmailTemplateDialog {
  protected readonly emailTypes = EMAIL_TEMPLATE_EVENT_TYPES;

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  dialogConfig?: DialogConfig;
  saving = false;

  form = this.formBuilder.group({
    type: [this.emailTypes[0] ?? null, Validators.required],
    templateLabel: ['', Validators.required],
    subject: ['', Validators.required],
    byline: [''],
    content: ['', Validators.required],
  });

  constructor(
    private formBuilder: FormBuilder,
    private emailTemplatesSvc: EmailTemplatesService,
    private toastSvc: ToastService
  ) {}

  open() {
    this.resetForm();
    this.dialog.open();
  }

  close() {
    this.dialog.close();
  }

  resetForm() {
    this.form.reset({
      type: this.emailTypes[0] ?? null,
      templateLabel: '',
      subject: '',
      byline: '',
      content: '',
    });
    this.form.markAsPristine();
  }

  cancel() {
    this.resetForm();
    this.close();
  }

  async submit() {
    if (this.form.invalid) return;

    this.saving = true;

    const created = await this.emailTemplatesSvc
      .createTemplate({
        type: this.form.controls.type.value as EmailTemplateEventType,
        templateLabel: this.form.controls.templateLabel.value ?? null,
        subject: this.form.controls.subject.value ?? null,
        byline: this.form.controls.byline.value ?? null,
        content: this.form.controls.content.value ?? null,
      })
      .catch(() => {
        this.toastSvc.show({
          type: 'error',
          title: 'Something went wrong',
          text: 'Unable to create email template.',
        });
        return null;
      });

    if (created?.id) {
      this.toastSvc.show({
        type: 'success',
        title: 'Created email template',
        text: 'The template has been successfully created.',
      });
      this.close();
    }

    this.saving = false;
  }
}
